import * as React from "react"

import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

interface DividerTypographyProps {
    borderColor?: string,
}

class DividerTypography extends React.Component<DividerTypographyProps & WithStyles<typeof styles>, any> {

    render() {
        const classes = this.props.classes;

        return (
            <div className={classes.container}>
                <div className={classes.border} style={{ borderColor: this.props.borderColor ? this.props.borderColor : 'rgb(170, 170, 170)' }} />
                <Typography color='primary' component='legend' className={classes.content}>
                    {this.props.children}
                </Typography>
                <div className={classes.border} style={{ borderColor: this.props.borderColor ? this.props.borderColor : 'rgb(170, 170, 170)' }} />
            </div>
        );
    }
}

const styles = (theme: Theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
    },
    border: {
        borderBottom: '1px solid',
        width: '100%',
    },
    content: {
        padding: '0 10px 0 10px',
        fontSize: '14px',
    }
});

export default withStyles(styles)(DividerTypography);